import React from 'react';
import { IconType } from 'react-icons';
import { AiFillTags, AiOutlineBlock, AiOutlineLayout } from 'react-icons/ai';
import {
  BsCardChecklist,
  BsClipboard2X,
  BsCollectionPlayFill,
  BsListCheck,
  BsStopwatch,
} from 'react-icons/bs';
import { CgList } from 'react-icons/cg';
import {
  FaFolderOpen,
  FaHome,
  FaMedal,
  FaPenSquare,
  FaSearch,
  FaStopwatch,
  FaTasks,
  FaUsers,
} from 'react-icons/fa';
import { GiChoice, GiHawkEmblem, GiPathDistance } from 'react-icons/gi';
import { ImFolderUpload } from 'react-icons/im';
import { IoFileTraySharp, IoPencilSharp, IoSearchSharp } from 'react-icons/io5';
import {
  MdAccessTime,
  MdAdd,
  MdArticle,
  MdAssignment,
  MdBookmarks,
  MdCheckCircle,
  MdFolder,
  MdInbox,
  MdLiveTv,
  MdManageSearch,
  MdMenuBook,
  MdNotifications,
  MdOutlineAdd,
  MdOutlineViewModule,
  MdPayment,
  MdPersonSearch,
  MdSchool,
  MdSpaceDashboard,
  MdSwapVert,
  MdVideoLibrary,
  MdViewModule,
} from 'react-icons/md';
import { Icon as ChakraIcon } from '@chakra-ui/react';

type Props = {
  name: string;
};

type IconMap = Record<string, IconType>;

const iconMap: IconMap = {
  // currently used in Side Menu
  home: FaHome,
  landing: AiOutlineLayout,
  plan: CgList,
  upsell: MdAssignment,
  payment: MdPayment,
  'uee-course': MdInbox,
  'postgrad-course': MdInbox,
  'uee-lessons': BsCollectionPlayFill,
  'postgrad-lessons': BsCollectionPlayFill,
  'uee-contents': MdFolder,
  'postgrad-contents': MdFolder,
  'uee-materials': ImFolderUpload,
  'postgrad-materials': ImFolderUpload,
  'uee-exercises': BsListCheck,
  'postgrad-exercises': BsListCheck,
  college: MdSchool,
  'processo-seletivo-v1': MdSchool,
  'processo-seletivo-v2': MdSchool,
  'college-windows': MdAccessTime,
  'college-courses': MdSchool,
  'college-disciplines': MdMenuBook,
  'college-discipline-instances': MdBookmarks,
  'college-assessments-management': MdCheckCircle,
  'college-lessons': MdSpaceDashboard,
  'college-lives': MdLiveTv,
  'college-curriculum-paths': GiPathDistance,
  'college-module-blocks': AiOutlineBlock,
  'college-modules': MdViewModule,
  'college-sub-modules': MdOutlineViewModule,
  'college-articles': MdArticle,
  'college-exercises': GiChoice,
  'college-students': MdSchool,
  'college-progress-backup': MdSchool,
  'college-dex-permissions': MdSchool,
  'college-review-lists': BsCardChecklist,
  'college-live-lessons': MdSchool,
  'college-p&r': MdSchool,
  'college-microcertificate': MdSchool,
  'college-notifications': MdNotifications,
  'college-videos': MdVideoLibrary,
  'discipline-registration-reports': MdManageSearch,
  'manage-enrollment': MdPersonSearch,
  'manage-student': MdPersonSearch,
  'bulk-course-enrollment': FaTasks,
  'assessments-evaluate-think-and-answer': FaPenSquare,
  'assessments-evaluate-practices': FaPenSquare,
  'assessments-activities-dates-and-grades': FaSearch,
  'assessments-deadline-extension': FaStopwatch,
  'assessments-grades-consolidation-processes': FaFolderOpen,
  'microcertificates-manual-eligibility': FaMedal,
  'evaluation-overrides': BsClipboard2X,
  blackhawk: GiHawkEmblem,
  category: AiFillTags,
  users: FaUsers,

  // other usages
  'assessments-management-fileTray': IoFileTraySharp,
  'assessments-management-pencil': IoPencilSharp,
  'assessments-management-search': IoSearchSharp,
  'assessments-late-submission-watch': BsStopwatch,
  'assessments-late-submission-add': MdOutlineAdd,
  swap_vert: MdSwapVert,
  add: MdAdd,
};

const Icon = ({ name }: Props): React.ReactElement => {
  const FALLBACK_ICON = FaTasks;
  const iconName = iconMap[name];
  return <ChakraIcon as={iconName || FALLBACK_ICON} />;
};

export default Icon;
